/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { Outlet, Route, Routes } from "react-router-dom";

import { ForgotPassword } from "./components/ForgotPassword";
import { Registration } from "./components/Registration";
import { toAbsoluteUrl } from "@/../_metronic/helpers";
import { useThemeMode } from "@/../_metronic/partials";
import { Login } from "./components/Login";

const AuthLayout = () => {
	const { mode } = useThemeMode();
	const intl = useIntl();

	useEffect(() => {
		document.body.style.backgroundImage = "none";
		return () => {};
	}, []);

	return (
		<div
			className="w-100 h-100 bgi-no-repeat bgi-size-cover bgi-attachment-fixed"
			style={{
				backgroundImage: `url(${toAbsoluteUrl(
					mode === "dark"
						? "/media/illustrations/sketchy-1/fundo-dark-saude-integrada.png"
						: "/media/illustrations/sketchy-1/fundo-light-saude-integrada.png"
				)})`,
			}}
		>
			<div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20 h-100">
				<div className="w-lg-450px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
					<div className="d-flex justify-content-center">
						<span className="mb-12">
							<img
								alt="Logo do Saúde Integrada no modo escuro"
								src={toAbsoluteUrl("/media/logos/logo-saude-integrada.svg")}
								className="theme-dark-show h-60px"
							/>

							<img
								alt="Logo do Saúde Integrada no modo claro"
								src={toAbsoluteUrl("/media/logos/logo-saude-integrada.svg")}
								className="theme-light-show h-60px"
							/>
						</span>
					</div>

					<Outlet />
				</div>

				<div className="mt-8">
					<div className="text-center mb-2">
						<span>
							{intl.formatMessage({ id: "AUTH.VALIDATION.TEXT.ONE_PRODUCT" })}
						</span>
					</div>

					<img
						alt="Logo da empresa MultIntegrada no modo escuro"
						src={toAbsoluteUrl(
							"/media/illustrations/sketchy-1/logo-dark-multintegrada.png"
						)}
						className="theme-dark-show h-45px"
					/>

					<img
						alt="Logo da empresa MultIntegrada no modo claro"
						src={toAbsoluteUrl("/media/logos/logo-multIntegrada-horizontal.svg")}
						className="theme-light-show h-45px"
					/>
				</div>
			</div>
		</div>
	);
};

const AuthPage = () => (
	<Routes>
		<Route element={<AuthLayout />}>
			<Route path="login" element={<Login />} />
			<Route path="registration" element={<Registration />} />
			<Route path="forgot-password" element={<ForgotPassword />} />
			<Route index element={<Login />} />
		</Route>
	</Routes>
);

export { AuthPage };
